import React from 'react';
import { Link } from 'react-router-dom';
import './corporate.css';

const Corporate = () => {
  return (
    <div className="corporate-page">
      {/* Hero */}
      <section className="corp-hero">
        <div className="container">
          <h1>MOJ for Business</h1>
          <p>Enterprise-grade transportation solutions for companies across Pakistan</p>
          <Link to="/contact" className="btn-primary">Contact Sales</Link>
        </div>
      </section>

      {/* Current Clients Showcase */}
      <section className="current-clients">
        <div className="container">
          <h2 className="section-title">Companies Already Riding With Us</h2>
          <div className="clients-showcase">
            <div className="showcase-card featured">
              <div className="client-logo">SA</div>
              <h3>Sareen Air</h3>
              <p>Complete staff transportation solution for aviation operations. Daily routes between Islamabad and Lahore airports.</p>
              <div className="testimonial">
                "MOJ has streamlined our crew logistics with reliable, on-time service."
              </div>
            </div>
            
            <div className="showcase-card featured">
              <div className="client-logo">MA</div>
              <h3>Menzies Aviation</h3>
              <p>Aviation services transportation support across major Pakistan airports with 24/7 operational reliability.</p>
               <div className="testimonial">
                "MOJ supports our airport operations with dependable crew and staff mobility."
               </div>
            </div>
            
            <div className="showcase-card">
              <div className="client-logo">NI</div>
              <h3>Nisum</h3>
              <p>Tech talent transportation with flexible scheduling for shift workers.</p>
            </div>
            
            <div className="showcase-card">
              <div className="client-logo">NG</div>
              <h3>Netline Group</h3>
              <p>Multi-location employee transport across Rawalpindi and Islamabad offices with centralized billing.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="corp-features">
        <div className="container">
          <h2 className="section-title">Built for Business</h2>
          <div className="corp-grid">
            <div className="corp-feature">
              <h3>📊 Centralized Billing</h3>
              <p>One monthly invoice for all rides. No more expense reports or reimbursements.</p>
            </div>
            <div className="corp-feature">
              <h3>📍 Live Tracking</h3>
              <p>Monitor all company rides in real-time from a single dashboard.</p>
            </div>
            <div className="corp-feature">
              <h3>🔒 Safety First</h3>
              <p>Verified drivers, trip recording, and 24/7 priority support for your employees.</p>
            </div>
            <div className="corp-feature">
              <h3>📈 Usage Reports</h3>
              <p>Detailed analytics on travel patterns, costs, and carbon footprint.</p>
            </div>
            <div className="corp-feature">
              <h3>🎯 Custom Routes</h3>
              <p>Set up dedicated routes for your offices, airports, or client locations.</p>
            </div>
            <div className="corp-feature">
              <h3>💼 Account Manager</h3>
              <p>Dedicated support representative for your company.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="corp-cta">
        <div className="container">
          <h2>Join Pakistan's Leading Companies</h2>
          <p>Get a customized transportation solution for your business</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn-primary">Request Demo</Link>
            <a href="mailto:info@mojexpress.com" className="btn-secondary">Email Sales Team</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Corporate;
